import React from 'react';
import { EVIDENCE_TIERS as TIER_CONFIG } from '../../../constants/evidenceTiers';

const EvidenceQualityBar = ({ breakdown = {}, progressPercentage = 0 }) => {
  const counts = {
    auto_verified:      breakdown?.auto_verified      ?? 0,
    manually_evidenced: breakdown?.manually_evidenced ?? 0,
    self_attested:      breakdown?.self_attested      ?? 0,
    none:               breakdown?.none               ?? 0,
  };

  const total = Object.values(counts).reduce((sum, n) => sum + n, 0);

  const getWidth = (count) => {
    if (total === 0) return 0;
    return (count / total) * 100;
  };

  const getPercent = (count) => {
    if (total === 0) return 0;
    return Math.round((count / total) * 100);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-sm font-medium text-gray-600 mb-4">Evidence Quality</h3>

      {/* Stacked bar */}
      <div className="flex w-full h-4 rounded-full overflow-hidden bg-gray-200 mb-4">
        {total === 0 ? (
          <div className="w-full h-full bg-gray-200" />
        ) : (
          TIER_CONFIG.map((tier) => {
            const width = getWidth(counts[tier.key]);
            if (width === 0) return null;
            return (
              <div
                key={tier.key}
                className={`${tier.color} h-full transition-all duration-500`}
                style={{ width: `${width}%` }}
                title={`${tier.label}: ${counts[tier.key]}`}
              />
            );
          })
        )}
      </div>

      {/* Legend */}
      <div className="space-y-1.5 mb-4">
        {TIER_CONFIG.map((tier) => {
          const count = counts[tier.key];
          const pct = getPercent(count);
          return (
            <div key={tier.key} className="flex items-center justify-between text-xs text-gray-600">
              <div className="flex items-center gap-2">
                <span
                  className={`inline-block w-2.5 h-2.5 rounded-sm flex-shrink-0 ${tier.color}`}
                />
                <span>{tier.label}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-800">{count}</span>
                <span className="text-gray-400 w-8 text-right">{pct}%</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Overall audit-ready label */}
      <div className="pt-3 border-t border-gray-100">
        <p className="text-sm text-center text-gray-500">
          <span className="font-semibold text-gray-800">{Math.round(progressPercentage)}%</span>
          {' '}overall audit-ready
        </p>
      </div>
    </div>
  );
};

export default EvidenceQualityBar;
